import { createStore } from 'vuex';

export default createStore({
    state: {
        user: null,  // Stocke les informations de l'utilisateur
        token: null, // Stocke le token JWT
    },
    mutations: {
        setUser(state, user) {
            state.user = user;  // Mettre à jour l'utilisateur dans l'état
        },
        setToken(state, token) {
            state.token = token;  // Mettre à jour le token
        },
    },
    actions: {
        login({ commit }, { user, token }) {
            commit('setUser', user);  // Stocker l'utilisateur dans Vuex
            commit('setToken', token);  // Stocker le token dans Vuex
            localStorage.setItem('token', token);  // Sauvegarder le token dans localStorage
            localStorage.setItem('user', JSON.stringify(user));  // Sauvegarder l'utilisateur dans localStorage
        },
        logout({ commit }) {
            commit('setUser', null);  // Supprimer l'utilisateur
            commit('setToken', null);  // Supprimer le token
            localStorage.removeItem('token');  // Supprimer le token de localStorage
            localStorage.removeItem('user');  // Supprimer l'utilisateur de localStorage
        },
        init({ commit }) {
            const token = localStorage.getItem('token');
            const user = localStorage.getItem('user');
            if (token && user) {
                commit('setToken', token);
                commit('setUser', JSON.parse(user));
            }
        }
    },
    getters: {
        userName(state) {
            return state.user ? state.user.username : 'Utilisateur';  // Accéder au nom d'utilisateur
        },
        getUser(state) {
            return state.user;
        },
    },
});
